module.exports = "<gw-pl-yes-no model=\"fakeVM\"></gw-pl-yes-no>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/table/templates/Boolean.html
// module id = 445
// module chunks = 0